import React from 'react';
import { SvgIcon } from '@mui/material';

const SettingsCircleIcon = React.forwardRef((props, ref) => {
	const { sx, ...other } = props;
	
	return (
		<SvgIcon
			ref={ref}
			viewBox="0 0 16 16"
			sx={sx}
			{...other}
		>
			<g clipPath="url(#clip0_1821_3695)">
				<path 
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.00004 0.833984C4.04204 0.833984 0.833374 4.04265 0.833374 8.00065C0.833374 11.9587 4.04204 15.1673 8.00004 15.1673C11.958 15.1673 15.1667 11.9587 15.1667 8.00065C15.1667 4.04265 11.958 0.833984 8.00004 0.833984ZM1.83337 8.00065C1.83337 6.47798 2.38537 5.08398 3.30004 4.00798L5.43537 6.14265C5.04313 6.68267 4.83235 7.33322 4.83337 8.00065C4.83235 8.66809 5.04313 9.31863 5.43537 9.85865L3.30004 11.9933C2.35054 10.88 1.83034 9.46388 1.83337 8.00065ZM6.14204 5.43598L4.00737 3.30065C5.1207 2.35115 6.53681 1.83095 8.00004 1.83398C9.52271 1.83398 10.9167 2.38598 11.9927 3.30065L9.85737 5.43598C9.31754 5.04388 8.66725 4.8331 8.00004 4.83398C7.3326 4.83296 6.68206 5.04374 6.14204 5.43598ZM4.00737 12.7007C5.1207 13.6502 6.53681 14.1703 8.00004 14.1673C9.46327 14.1703 10.8794 13.6502 11.9927 12.7007L9.85737 10.5653C9.31754 10.9574 8.66725 11.1682 8.00004 11.1673C7.3326 11.1683 6.68206 10.9576 6.14204 10.5653L4.00737 12.7007ZM10.5647 9.85798L12.7 11.9933C13.6495 10.88 14.1697 9.46388 14.1667 8.00065C14.1697 6.53742 13.6495 5.12131 12.7 4.00798L10.5647 6.14265C10.957 6.68267 11.1677 7.33322 11.1667 8.00065C11.1677 8.66809 10.957 9.31797 10.5647 9.85798ZM5.83337 8.00065C5.83337 7.42602 6.06165 6.87492 6.46798 6.46859C6.87431 6.06226 7.42541 5.83398 8.00004 5.83398C8.57468 5.83398 9.12578 6.06226 9.53211 6.46859C9.93843 6.87492 10.1667 7.42602 10.1667 8.00065C10.1667 8.57529 9.93843 9.12639 9.53211 9.53272C9.12578 9.93904 8.57468 10.1673 8.00004 10.1673C7.42541 10.1673 6.87431 9.93904 6.46798 9.53272C6.06165 9.12639 5.83337 8.57529 5.83337 8.00065Z" 
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1821_3695">
					<rect width="16" height="16" fill="white"/>
				</clipPath>
			</defs>
		</SvgIcon>
	);
});

SettingsCircleIcon.displayName = 'SettingsCircleIcon';

export default SettingsCircleIcon;
